import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import SelectImage from "@builder/components/general/SelectImage";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ImageNode } from "@common/build/types";





const ImageFallback = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode) as ImageNode
    
    const imageCallback = () => {
        dispatch(setImageState(["image", "urlFallback"]));
        dispatch(setCurrentPopup("images"));
    };

    const removeImageCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: ["image", "urlFallback"], value: "", remove: true }));
    }

    return (
        <SidebarCollapse title="Image Fallback" parent={parent}>
            <SelectImage
                type="image"
                callback={imageCallback}
                removeCallback={removeImageCallback}
                img={selectedNode.image?.urlFallback}
            />


        </SidebarCollapse>
    );
};

export default ImageFallback;
